import { render, staticRenderFns } from "./AddUpdateMenu.vue?vue&type=template&id=5889d0af&scoped=true&"
import script from "./AddUpdateMenu.vue?vue&type=script&lang=js&"
export * from "./AddUpdateMenu.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateMenu.vue?vue&type=style&index=0&id=5889d0af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5889d0af",
  null
  
)

export default component.exports